// extracted by mini-css-extract-plugin
module.exports = {"container":"WalletNotFound-container","headertext":"WalletNotFound-headertext","contactUsButton":"WalletNotFound-contactUsButton"};